import type { Logger } from '@feature-hub/logger';
import type { VueFormatterServiceInterfaceV1, LocaleServiceV1 } from './feature-service-types';
import { normalizeContent } from './components/normalizeContent';
import type { AppContent, FalconContent } from '../../@types/interfaces';
import { isWltpComplianceSatisfied } from './wltpCompliance';

export interface SsrWltpPrecheckArgs {
  isMarketComplianceEnabled: boolean;
  content: unknown;
  vueFormatterService?: VueFormatterServiceInterfaceV1;
  serviceLocale?: LocaleServiceV1;
  logger: Pick<Logger, 'warn' | 'error'>;
  onCaeMissingLog?: (message: string) => void;
}

export const runSsrWltpPrecheck = async ({
  isMarketComplianceEnabled,
  content,
  vueFormatterService,
  serviceLocale,
  logger,
  onCaeMissingLog,
}: SsrWltpPrecheckArgs): Promise<boolean | undefined> => {
  if (!isMarketComplianceEnabled) return undefined;
  if (!vueFormatterService || !serviceLocale) return undefined;

  try {
    const mapped = normalizeContent(content as AppContent | FalconContent);
    return await isWltpComplianceSatisfied(
      mapped.consumptionAndEmission,
      vueFormatterService,
      serviceLocale,
      logger,
      onCaeMissingLog,
    );
  } catch (err) {
    logger.warn('WLTP SSR compliance pre-check failed', err);
    return undefined;
  }
};
